import {
  ActivityPanelDTO,
  ActivityPanelResponseDTO,
  MacroReportRequest,
  MacroReportResponseDTO,
  MonthlyAutos,
  MonthlyConsumption,
  MonthlyRequest,
  PaymentReportPrint,
  PaymentReportRequest,
  PaymentReportsResponse,
} from './../model/activity-model';
import { CommonDataDTO } from './../../requests/model/combos-model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActivityService {
  constructor(private _http: HttpClient) {}

  // postGetEstablishments(prescriptorId: string): Observable<CommonDataDTO[]> {
  //   const parameters = new HttpParams().append('parentId', prescriptorId);
  //   return this._http.post<CommonDataDTO[]>(
  //     environment.URL_BASE_REQUEST + environment.subUrlControlPanelEstablishments,
  //     null,
  //     { params: parameters }
  //   );
  // }

  // postGetPrescribers(): Observable<CommonDataDTO[]> {
  //   return this._http.post<CommonDataDTO[]>(
  //     environment.URL_BASE_REQUEST + environment.subUrlControlPanelPrescribersByCase,
  //     {}
  //   );
  // }

  postGetPaymentReports(request: PaymentReportRequest): Observable<PaymentReportsResponse> {
    return this._http.post<PaymentReportsResponse>(
      environment.URL_BASE_REQUEST + environment.subUrlPaymentReports,
      request
    );
  }

  postPrintPaymentReport(numOperation: PaymentReportPrint, language: string) {
    const httpOptions = { responseType: 'blob' as 'json' };
    return this._http.post<any>(
      `${environment.URL_BASE_REQUEST}${environment.subUrlPaymentReportsPrint}?language=${language}`,
      numOperation,
      httpOptions
    );
  }

  postGetActivityPanel(activityPanelDTO: ActivityPanelDTO): Observable<ActivityPanelResponseDTO[]> {
    return this._http.post<ActivityPanelResponseDTO[]>(
      environment.URL_BASE_REQUEST + environment.SubUrlActivityPanel,
      activityPanelDTO
    );
  }

  postGetStatus(): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(environment.URL_BASE_REQUEST + environment.subUrlActivityStatus, null);
  }

  postGetActivityMacros(activityMacro: MacroReportRequest): Observable<MacroReportResponseDTO[]> {
    return this._http.post<MacroReportResponseDTO[]>(
      environment.URL_BASE_REQUEST + environment.subUrlActivityMacros,
      activityMacro
    );
  }

  postGetActivityMacrosExcel(activityMacro: MacroReportRequest): Observable<MacroReportResponseDTO[]> {
    return this._http.post<MacroReportResponseDTO[]>(
      environment.URL_BASE_REQUEST + environment.subUrlActivityMacrosExcel,
      activityMacro
    );
  }

  postGetMontlyAutosReport(request: MonthlyRequest): Observable<MonthlyAutos[]> {
    return this._http.post<MonthlyAutos[]>(
      environment.URL_BASE_REQUEST + environment.subUrlGetMonthlyReportAutos,
      request
    );
  }

  postGetMontlyConsumptionReport(request: MonthlyRequest): Observable<MonthlyConsumption[]> {
    return this._http.post<MonthlyConsumption[]>(
      environment.URL_BASE_REQUEST + environment.subUrlGetMonthlyReportConsumption,
      request
    );
  }
}
